
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { PlusIcon } from "lucide-react"
import { SubscriptionTable } from "@/components/subscriptions/subscription-table"
import { AddSubscriptionDialog } from "@/components/subscriptions/add-subscription-dialog"

export default function SubscriptionsPage() {
  const { t } = useTranslation()
  const [showAddDialog, setShowAddDialog] = useState(false)

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">{t("subscriptions.title")}</h1>
        <Button onClick={() => setShowAddDialog(true)}>
          <PlusIcon className="h-4 w-4 mr-2" />
          {t("subscriptions.addSubscription")}
        </Button>
      </div>

      <div className="border rounded-lg">
        <h2 className="p-4 font-medium border-b">{t("subscriptions.plansList")}</h2>
        <SubscriptionTable />
      </div>

      <AddSubscriptionDialog open={showAddDialog} onOpenChange={setShowAddDialog} />
    </div>
  )
}
